export const getSignedFileFromHistory = (actionHistory, originalFileId, action) => {
  if (!actionHistory) return null

  const historyEntry = actionHistory.find(h => h.action === action)
  if (!historyEntry) return null

  try {
    const dataAfter = JSON.parse(historyEntry.dataAfter || '[]')
    if (dataAfter.length > 0 && dataAfter[0].mainFiles) {
      return (
        dataAfter[0].mainFiles.find(f => f.originalFileId === originalFileId) ||
        null
      )
    }
  } catch (e) {
    console.error('Error parsing history:', e)
  }

  return null
}

export const isFileSignedAtStep = (signedFilesTracking, fileIndex, signStep) =>
  signedFilesTracking[signStep]?.has(fileIndex) || false
